<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filteredk="onFiltered"
              >
                <template #cell(btn)="row">
                  <b-button variant="success" class="w-sm">
                    <i class="mdi mdi-pencil d-block font-size-8" @click="editMaster(row.item.id)"></i> Edit
                  </b-button>
                  <b-button variant="danger" class="w-sm">
                    <i class="mdi mdi-trash-can d-block font-size-8" @click="deleteMaster(row.item.id)"></i> Hapus
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="text-sm-right">
        <router-link tag="a" to="/tujuan_pembelajaran/add" class="btn btn-success">
          <i class="mdi mdi-truck-fast mr-1"></i> Add Tujuan Pembelajaran
        </router-link>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Vue from "vue";
import axios from "axios";
export default {
  name: "tujuan_pembelajaran.vue",
  page: {
    title: "Advanced Table",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Tujuan Pembelajaran",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "id", sortable: true },
        { key: "tingkat_sekolah_id", sortable: true, label: "Tingkat Sekolah" },
        { key: "mapel_name", sortable: true, label: "Mata Pelajaran" },
        { key: "name", sortable: true },
        { key: "btn", label: "Action"},
      ]
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    tableData: function() {
      return (this.$store.getters['tujuanpembelajaran/tujuan_pembelajarans']) ? this.$store.getters['tujuanpembelajaran/tujuan_pembelajarans'] : []
    },
    rows: function() {
      return (this.$store.getters['tujuanpembelajaran/paginate'].total) ? this.$store.getters['tujuanpembelajaran/paginate'].total : 0
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    let paramsTemp = queryString.stringify({
      ...{
        name: null,
        sort: '-id',
      }
      , ...this.options}
    )
    this.$store.dispatch('tujuanpembelajaran/GET_TUJUAN_PEMBELAJARANS',{masterType: this.$route.meta.name,params:paramsTemp}).then(()=>{})
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async providerData(ctx, callback) {
      let paramsTemp = queryString.stringify({
        ...{
          name: null,
          sort: (ctx.sortDesc ? '' : '-') + ctx.sortBy,
          page: ctx.currentPage,
          limit: ctx.perPage
        }
        , ...this.options}
      )
      this.$store.dispatch(
          'tujuanpembelajaran/GET_TUJUAN_PEMBELAJARANS',{masterType: this.$route.meta.name,params:paramsTemp}
      ).then(()=>{
        this.stillLoading=false
        // return tableData
        return (this.$store.getters['tujuanpembelajaran/tujuan_pembelajarans']) ? this.$store.getters['tujuanpembelajaran/tujuan_pembelajarans'] : []
      }) .catch(function() {
        return []
      })
    },
    editMaster(masterId){
      this.$router.push('/tujuan_pembelajaran/edit/'+masterId)
    },
    deleteMaster(masterId, name) {
      Vue.swal.fire({
        title: "Yakin, hapus data ini",
        text: name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Iya, hapus!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('tujuanpembelajaran/DELETE_TUJUAN_PEMBELAJARAN', masterId).then((resp) => {
            if (resp.data.status == '200 OK') {
              this.successmsg("Data telah terhapus.")
              this.$router.go()
            } else {
              this.warningmsg(resp.data.message)
            }
          })
        }
      });
    },
    successmsg(text) {
      Vue.swal.fire({
        position: "top-end",
        icon: "success",
        title: text,
        showConfirmButton: false,
        timer: 1500
      });
    },
    warningmsg(text) {
      Vue.swal.fire({
        position: "top-end",
        icon: "warning",
        title: text,
        showConfirmButton: false,
        timer: 1500
      });
    },
    httpCallTujuanPembelajaranData(params) {
      this.$store.dispatch('tujuanpembelajaran/GET_TUJUAN_PEMBELAJARANS',{masterType: this.$route.meta.name,params:params}).then(()=>{
        return (this.$store.getters['tujuanpembelajaran/tujuan_pembelajarans']) ? this.$store.getters['tujuanpembelajaran/tujuan_pembelajarans'] : []
      })
    },
  },
  watch: {
    filter: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        name: value,
        sort: '-id',
      })
      this.httpCallTujuanPembelajaranData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallTujuanPembelajaranData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallTujuanPembelajaranData(params)
      }
    },
  },
}
</script>

<style scoped>

</style>